import { Component, OnInit } from '@angular/core';
import { AbstractComponent } from 'app/shared/components/abstract-component/abstract.component';
import { ComparatorService } from 'app/shared/services/comparator-service';
import { ListLoaderPreloaded } from 'app/shared/components/list-loader/list-loader-preloaded';
import { AuftragSearchResponseMeta, BatchAuftragListEntryMeta, BatchAuftragService } from 'app/core/batch-auftrag-api';
import { TableSortModel } from 'app/shared/tablesort/tableSortModel';
import { KompaktBenutzerPipe } from 'app/shared/kompaktdarstellung/benutzer/kompakt-benutzer-pipe';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { DeleteCheckModalComponent } from 'app/shared/components/modals/delete-check-modal/delete-check-modal.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AppPermissionService } from 'app/core/services/app-permission.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ContentHeaderComponent } from '../../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../../shared/components/title/title.component';
import { TitleFunctionbarComponent } from '../../../../shared/components/title-functionbar/title-functionbar.component';
import { FunctionbarSearchresultButtonsComponent } from '../../../../shared/components/title-functionbar/functionbar-searchresult-buttons/functionbar-searchresult-buttons.component';
import { ListLoaderWrapperComponent } from '../../../../shared/components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { ColumnHeaderComponent } from '../../../../shared/tablesort/sort-icon/column-header.component';
import { LinkComponent } from '../../../../shared/components/link/link.component';
import { CapSpinnerSmallComponent } from '../../../../shared/components/cap-spinner-small/cap-spinner-small.component';
import { DatumPipe } from '../../../../shared/pipes/simple/datum.pipe';
import { KompaktBenutzerPipe as KompaktBenutzerPipe_1 } from '../../../../shared/kompaktdarstellung/benutzer/kompakt-benutzer-pipe';

@Component({
  selector: 'cap-auftrag-list',
  templateUrl: './auftrag-list.component.html',
  styleUrls: ['./auftrag-list.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    TitleFunctionbarComponent,
    FunctionbarSearchresultButtonsComponent,
    ListLoaderWrapperComponent,
    NgTemplateOutlet,
    ColumnHeaderComponent,
    LinkComponent,
    NgbTooltip,
    CapSpinnerSmallComponent,
    TranslatePipe,
    DatumPipe,
    KompaktBenutzerPipe_1
  ]
})
export class AuftragListComponent extends AbstractComponent implements OnInit {
  auftragLoader: ListLoaderPreloaded<BatchAuftragListEntryMeta>;
  auftragResponse: AuftragSearchResponseMeta;

  tableSortModel = new TableSortModel<BatchAuftragListEntryMeta>('table', this.comparatorService);

  permissionAuftragAdmin;

  constructor(
    protected router: Router,
    private route: ActivatedRoute,
    private comparatorService: ComparatorService,
    private kompaktBenutzerPipe: KompaktBenutzerPipe,
    private modalService: NgbModal,
    private translateService: TranslateService,
    private auftragservice: BatchAuftragService,
    private permissionService: AppPermissionService
  ) {
    super();
    keysToTranslate<string>(['auftrag.ListTitel', 'tooltip.detailsAuftrag', 'batch.auftrag.delete.message', 'AuftragLoeschen']);

    this.tableSortModel.addColumn('auftragNr', (a, b) => +a.auftragNr - +b.auftragNr).switchSortDirection();
    this.tableSortModel.addColumn(
      'auftragTyp',
      (a, b) => this.comparatorService.translatedStringComparator(a.datenexportAuftragTyp, b.datenexportAuftragTyp),
      null
    );
    this.tableSortModel.addColumn(
      'ersteller',
      (a, b) =>
        this.comparatorService.translatedStringComparator(
          this.kompaktBenutzerPipe.transform(a.ersteller),
          this.kompaktBenutzerPipe.transform(b.ersteller)
        ),
      null
    );
    this.tableSortModel.addColumn(
      'verarbeitungsstatus',
      (a, b) => this.comparatorService.translatedStringComparator(a.exportResultWebTyp, b.exportResultWebTyp),
      null
    );
    this.tableSortModel.addColumn('erstelldatum', (a, b) => this.comparatorService.orderByComparator(a.erstelldatum, b.erstelldatum), null);
    this.tableSortModel.addColumn('startdatum', (a, b) => this.comparatorService.orderByComparator(a.startdatum, b.startdatum), null);
    this.tableSortModel.addColumn('enddatum', (a, b) => this.comparatorService.orderByComparator(a.enddatum, b.enddatum), null);
  }

  ngOnInit() {
    this.permissionAuftragAdmin = this.permissionService.hasPermission('DATENEXPORT_AUFTRAG_ADMIN');

    this.addSub(
      this.route.data.subscribe((data) => {
        this.auftragResponse = data.entity;
        this.createListLoader(this.auftragResponse.results);
      })
    );
  }

  onReset(auftragId: string) {
    const modal = this.modalService.open(DeleteCheckModalComponent);
    modal.componentInstance.entity = this.translateService.instant('batch.auftrag.delete.message');
    modal.result.then(
      () => {
        this.auftragservice.deleteDatenExportAuftragById(auftragId).subscribe(() => {
          this.createListLoader(this.auftragLoader.allItems.filter((i) => i.id.id !== auftragId));
        });
      },
      () => {
        // modal closed
      }
    );
  }

  private createListLoader(data: Array<BatchAuftragListEntryMeta>) {
    this.auftragLoader = new ListLoaderPreloaded<BatchAuftragListEntryMeta>(15, 1, data);
    this.auftragLoader.applySortModel(this.tableSortModel);
  }
}
